import { createBrowserRouter, redirect } from "react-router-dom"
import App from "./App"
import OpenAIImage from "./pages/OpenAIImage"
import OpenAIText from "./pages/OpenAIText"
import OpenAIVoice from "./pages/OpenAIVoice"

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      { path: "/text", element: <OpenAIText /> },
      { path: "/image", element: <OpenAIImage /> },
      { path: "/voice", element: <OpenAIVoice /> },
    ],
  },
  {
    path: "*",
    loader: () => redirect("/"),
  },
])

export default router
